import { render, staticRenderFns } from "./VideoStyle.vue?vue&type=template&id=cb672a9c&scoped=true&"
import script from "./VideoStyle.vue?vue&type=script&lang=ts&"
export * from "./VideoStyle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb672a9c",
  null
  
)

export default component.exports